export function deleteEditable(obj) {
    if (obj !== null && typeof obj === "object") {
        for (const [key, value] of Object.entries(obj)) {
            if (key.includes("editable")) {
                delete obj[key];
            }
            else if (key === "belong_data" && Array.isArray(value)) {
                value.map((innerItem) => {
                    deleteEditable(innerItem);
                });
            }
        }
    }
}
